import * as Yup from 'yup';

// Same format rules as the legacy agent-profile enquiry form
// (src/components/shared/enquiry-form/form.tsx) - postcode/email/message are
// unchanged. Phone drops its format check: the ticket requires phone to
// never show a validation error.
export const enquiryValidationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string()
    .email('Email address should be valid')
    .required('Email address is required'),
  phone: Yup.string(),
  message: Yup.string(),
  postcode: Yup.string()
    .required('Postcode is required')
    .matches(/^[0-9]+$/, 'Postcode should be valid')
    .min(4, 'Postcode should be valid')
    .max(4, 'Postcode should be valid'),
});

export interface EnquiryFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  postcode: string;
  message: string;
  enquiryTypes: string[];
}

export const ENQUIRY_FORM_INITIAL_VALUES: EnquiryFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  postcode: '',
  message: '',
  enquiryTypes: [],
};

export const ENQUIRY_TYPE_OPTIONS = [
  { value: 'Selling my property', label: 'Selling my property' },
  { value: 'Leasing my property', label: 'Leasing my property' },
  { value: 'Buying a property', label: 'Buying a property' },
  { value: 'Renting a property', label: 'Renting a property' },
];
